<template>
  <div class="general_widget_container">
    <div
      :class="{
        'general_widget': true,
        'enter-in': scrollHalfFlag,
      }"
    >
      <div v-if="useMemory" class="memory_button" @click="sendMemoryGA()">
        <div
          :class="{
            'memory_button_image': true,
            'memory_button_image-active': memoryTopHoverFlag,
          }"
          @mouseover="memoryButtonHover()"
          @mouseleave="memoryButtonHover()"
        >
          <a title="寫一封信給921" :href="outLinkPath" target="_blank">
            <img
              :src="isMob ? require('../general_images/memory_mob.svg') : require('../general_images/memory_pc.svg')"
              alt="memory button"
            >
          </a>
        </div>
        <div
          :class="{
            'memory_button_image': true,
            'memory_button_image-active': memoryBottomHoverFlag,
          }"
          @mouseover="memoryButtonHover()"
          @mouseleave="memoryButtonHover()"
        >
          <a title="寫一封信給921" :href="outLinkPath" target="_blank">
            <img
              :src="isMob ? require('../general_images/memory_mob_hover.svg') : require('../general_images/memory_pc_hover.svg')"
              alt="memory button"
            >
          </a>
        </div>
      </div>
      <div v-scroll-to="'#app'" @click="sendGoTopGA()">
        <img class="go_top_button" src="../general_images/up.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';
import _throttle from 'lodash.throttle';

export default {
  name: 'GeneralWidget',
  props: {
    useMemory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollHalfFlag: false,
      moveUpFlag: false,
      moveDownFlag: false,
      memoryTopHoverFlag: true,
      memoryBottomHoverFlag: false,
      currentProgress: 0
    };
  },
  computed: {
    isMob() {
      return window.innerWidth > 768 ? false : true;
    },
    outLinkPath() {
      return location.origin + '/newmedia/921/memory/#/2';
    },
  },
  methods: {
    memoryButtonHover() {
      this.memoryTopHoverFlag = !this.memoryTopHoverFlag;
      this.memoryBottomHoverFlag = !this.memoryBottomHoverFlag;
    },
    handleScroll: _throttle(function() {
      const currentH = window.pageYOffset;
      const totalH = document.body.scrollHeight - window.innerHeight;
      this.currentProgress = (currentH / totalH) * 100;
      this.scrollHalfFlag = this.currentProgress > 50 ? true : false;
    }, 300),
    sendMemoryGA() {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "icon",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [memoryicon]"
      });
    },
    sendGoTopGA() {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "button",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [回到最上方]"
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
  .general_widget_container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 5000;
    margin: 5px 0;
    padding: 0 5px;
    overflow: hidden;
    .general_widget {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      transform: translateY(100%);
      transition: transform .5s ease-in-out;
    }
    .enter-in {
      transform: translateY(0);
    }
    .memory_button {
      position: relative;
      cursor: pointer;
      .memory_button_image {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition: .5s ease-in-out;
      }
      .memory_button_image-active {
        position: relative;
        opacity: 1;
      }
    }

    .go_top_button {
      margin: 10px 0;
      transition: .5s ease-in-out;
      cursor: pointer;
    }
  }

</style>
